import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Api from "../../../Services/Api";
import SimpleDDL from "../../../modules/SimpleDDL";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import { HttpStatus } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ComponentTabs from "./componentTabs";

class MasterBooking extends Component {
  contents = [
    { title: "Senin" },
    { title: "Selasa" },
    { title: "Rabu" },
    { title: "Kamis" },
    { title: "Jumat" },
    { title: "Sabtu" },
    { title: "Minggu" },
  ];

  constructor(props) {
    super(props);
    this.state = {
      deleteId: "",
      loading: false,
      printVisible: false,
      lastCabang: null,
      selectedData: null,
      pagination: {
        totalData: 0,
        limit: 5,
        page: 1,
      },
      listCabang: [],
      cabangOptions: [],
      isFetch: false,
      selectedIndex: 0,
      userAccess: {},
      dataBooking: {
        Senin: [],
        Selasa: [],
        Rabu: [],
        Kamis: [],
        Jumat: [],
        Sabtu: [],
        Minggu: [],
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    try {
      const response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).findAllMasterCabang();
      if (response.ok && !R.isEmpty(response.data.data)) {
        const cabangs = response.data.data;
        const allowedCabangs = this.props.menuAccess.map(
          (data) => data.idRefObj
        );

        const filteredData = cabangs
          .filter((item) => allowedCabangs.includes(item.kodeCabang))
          .map((c) => mapToObjectDDL(c.namaDealer, c.kodeCabang));

        const defaultCabang = filteredData.length > 0 ? [filteredData[0]] : [];

        await this.setState({
          cabangOptions: filteredData,
          listCabang: defaultCabang,
          lastCabang: defaultCabang,
        });
        await this.fetchData(defaultCabang[0]?.value);
      }
    } catch (error) {
      console.error("Error:", error);
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  fetchData = async (kodeCabang) => {
    const { selectedIndex, pagination } = this.state;
    const day = this.contents[selectedIndex].title.toUpperCase();
    const hariAktif = this.contents[selectedIndex].title;

    const payload = {
      kodeCabang,
      day,
      limit: pagination.limit,
      page: pagination.page,
    };

    this.setState({ isFetch: true });
    let userAccess = getUserAccess(this.props.menuAccess, kodeCabang);

    try {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterBooking,
        menuName: "Master Harga Part",
        setError: this.props.setError,
        args: payload,
      });
      const result = res?.data?.data || [];
      this.setState((prev) => ({
        dataBooking: {
          ...prev.dataBooking,
          [hariAktif]: result,
        },
        isFetch: false,
        resdata: res.data,
        userAccess: userAccess
      }));
    } catch (error) {
      this.setState({ isFetch: false,  userAccess: userAccess });
    }
  };

  handleCabangChange = async (value) => {
    const selectedCabang = value ? [value] : [];
    await this.setState({
      listCabang: selectedCabang,
      lastCabang: selectedCabang,
      pagination: {
        totalData: 0,
        limit: 5,
        page: 1,
      },
    });
    this.handleTriggerLoading();
    // this.handleRefreshPagination();
    await this.fetchData(selectedCabang[0]?.value);
    this.handleTriggerLoading();
  };

  handleTabDataChange = (hari, newData) => {
    this.setState((prev) => ({
      dataBooking: {
        ...prev.dataBooking,
        [hari]: newData,
      },
    }));
  };

  handlePrint = () => {
    this.setState((prev) => ({ ...prev, printVisible: !prev.printVisible }));
  };

  handleTabChange = async (index) => {
    this.setState({ selectedIndex: index }, async () => {
      const { listCabang } = this.state;
      const kodeCabang = listCabang[0]?.value;
      if (kodeCabang) {
        this.handleTriggerLoading();
        this.handleRefreshPagination();
        await this.fetchData(kodeCabang);
        this.handleTriggerLoading();
      }
    });
  };

  handleRefreshPagination = () => {
    this.setState((prevState) => ({
      ...prevState,
      pagination: {
        totalData: 0,
        limit: 5,
        page: 1,
      },
    }));
  };

  handleFetchPagination = (page, limit) => {
    const { listCabang, selectedIndex } = this.state;
    const kodeCabang = listCabang[0]?.value;

    if (!kodeCabang) return;

    this.setState(
      (prev) => ({
        pagination: {
          ...prev.pagination,
          page,
          limit,
        },
      }),
      () => this.fetchData(kodeCabang)
    );
  };

  render() {
    const {
      cabangOptions,
      listCabang,
      loading,
      printVisible,
      dataBooking,
      selectedIndex,
    } = this.state;

    return (
      <>
        <Container>
          <FlexView
            style={{ justifyContent: "space-between", alignItems: "center" }}
            className="margin-bottom-20px margin-top-5px"
          >
            <FlexView vAlignContent="center">
              <SimpleDDL
                id="select_options_nama_cabang"
                placeholder="Pilih Cabang"
                name="listCabang"
                box="search"
                containerclassname="margin-bottom-5px width width-250px"
                options={cabangOptions}
                value={listCabang[0] || null}
                onChange={this.handleCabangChange}
              />
            </FlexView>
          </FlexView>

          <Tabs selectedIndex={selectedIndex} onSelect={this.handleTabChange}>
            <TabList>
              {this.contents.map((content, idx) => (
                <Tab key={content.title + idx}>{content.title}</Tab>
              ))}
            </TabList>

            {this.contents.map((content, idx) => (
              <TabPanel key={content.title + idx}>
                <ComponentTabs
                  data={dataBooking[content.title] || []}
                  hari={content.title}
                  userAccess={this.state.userAccess}
                  resdata={this.state.resdata}
                  selectedCabang={listCabang[0] || null}
                  onDataChange={this.handleTabDataChange}
                  onRefresh={() => this.fetchData(listCabang[0]?.value)}
                  onFetchData={this.handleFetchPagination}
                  page={this.state.pagination.page}       
                  limit={this.state.pagination.limit}
                />
              </TabPanel>
            ))}
          </Tabs>
        </Container>

        {loading && <SimpleLoadingOverlay active={loading} />}
        {printVisible && <SimplePrintTable onClearPrint={this.handlePrint} />}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setError: (payload) => dispatch(ErrorAction.setError(payload)),
});

export default connect(null, mapDispatchToProps)(MasterBooking);
